import type { AdSlotKey } from "@/types/ads";
import type { ViteImportMeta } from "@/types/config";

const viteEnv = (import.meta as unknown as ViteImportMeta).env ?? {};

export const adsConfig = {
  enabled: viteEnv.VITE_ADSENSE_ENABLED === "true",
  client: viteEnv.VITE_ADSENSE_CLIENT || "",
  slots: {
    belowHero: viteEnv.VITE_ADSENSE_SLOT_HERO || "",
    midContent: viteEnv.VITE_ADSENSE_SLOT_CONTENT || "",
    beforeFaq: viteEnv.VITE_ADSENSE_SLOT_FAQ || ""
  } satisfies Record<AdSlotKey, string>
} as const;
